import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"phone\">\n    <path d=\"M6 0C4.34315 0 3 1.34315 3 3V17C3 18.6569 4.34315 20 6 20H14C15.6569 20 17 18.6569 17 17V3C17 1.34315 15.6569 0 14 0H6ZM5 3C5 2.44772 5.44772 2 6 2H14C14.5523 2 15 2.44772 15 3V17C15 17.5523 14.5523 18 14 18H6C5.44772 18 5 17.5523 5 17V3ZM9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H11C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14H9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol